import { render, staticRenderFns } from "./ConfigComprasPrazo.vue?vue&type=template&id=b2ef0f74&"
import script from "./ConfigComprasPrazo.vue?vue&type=script&lang=js&"
export * from "./ConfigComprasPrazo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports